import type { Product } from "~/types";

export function findCheapestProduct(products: Product[]) {
  let cheapest = products[0];
  for (const product of products) {
    if (product.price.usd < cheapest.price.usd) {
      cheapest = product;
    }
  }
  return cheapest;
}

export function isBusiness(product: Product) {
  return product.intent == 'business';
}